module.exports = __webpack_public_path__ + "media/Components/fonts/Raleway-38bff7e0cf0d28b234283e9564cdf803.ttf";